export function getSpacing(theme, value) {
    return Number(theme.spacing(value).slice(0, -2));
}
//# sourceMappingURL=getSpacing.js.map